import { useEffect, useState } from "react";
import ResponsableInstalacionForm from "./ResponsableInstalacionForm";

const initialValues = {
    cuitResponsable: "",
    numeroLicenciaHabilitante: "",
    domicilioHabilitacion: "",
    fechaExpedicion: null,
    fechaVencimiento: null,
};



const ResponesableInstalacionFormContainer = ({ open, handleClose, handleSubmit, values }) => {

    const [formInitialValues, setFormInitialValues] = useState();

    useEffect(() => {
        if (values) setFormInitialValues(values);
        else {
            setFormInitialValues(initialValues)
        }
    }, [values])



    return (
        <ResponsableInstalacionForm
            open={open}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            values={formInitialValues}
        />
    )
}


export default ResponesableInstalacionFormContainer;